import uniqBy from "lodash/uniqBy";
import uniq from "lodash/uniq";

export const MONTH_COUNT = 12;
export const COUNTRY_US = "US";

// Good locales reference
// https://stackoverflow.com/a/28357857
export const CURRENCIES = [
  {
    label: "Australia",
    value: "AU",
    code: "AUD",
    symbol: "$",
    locales: ["en-AU"]
  },
  {
    label: "Austria",
    value: "AT",
    code: "EUR",
    symbol: "€",
    locales: ["de-AT"]
  },
  {
    label: "Belgium",
    value: "BE",
    code: "EUR",
    symbol: "€",
    locales: ["nl-BE", "en-BE", "fr-BE", "de-BE"]
  },
  {
    label: "Brazil",
    value: "BR",
    code: "BRL",
    symbol: "R$",
    locales: ["pt-BR"]
  },
  {
    label: "Bulgaria",
    value: "BG",
    code: "BGN",
    symbol: "‎‎лв",
    locales: ["bg-BG", "bg"]
  },
  {
    label: "Canada",
    value: "CA",
    code: "CAD",
    symbol: "$",
    locales: ["en-CA", "fr-CA"]
  },
  {
    label: "Cyprus",
    value: "CY",
    code: "EUR",
    symbol: "€",
    locales: ["el-CY"]
  },
  {
    label: "Czech Republic",
    value: "CZ",
    code: "CZK",
    symbol: "Kč",
    locales: ["cs", "cs-CZ"]
  },
  {
    label: "Denmark",
    value: "DK",
    code: "DKK",
    symbol: "kr",
    locales: ["da-DK", "da"]
  },
  {
    label: "Estonia",
    value: "EE",
    code: "EUR",
    symbol: "€",
    locales: ["et-EE", "et"]
  },
  {
    label: "Finland",
    value: "FI",
    code: "EUR",
    symbol: "€",
    locales: ["fi-FI", "sv-FI"]
  },
  {
    label: "France",
    value: "FR",
    code: "EUR",
    symbol: "€",
    locales: ["fr"]
  },
  {
    label: "Germany",
    value: "DE",
    code: "EUR",
    symbol: "€",
    locales: ["de", "de-DE"]
  },
  {
    label: "Greece",
    value: "GR",
    code: "EUR",
    symbol: "€",
    locales: ["el-CY", "el-GR", "el"]
  },
  {
    label: "Hong Kong",
    value: "HK",
    code: "HKD",
    symbol: "$",
    locales: ["yue-Hant-HK", "zh-Hans-HK", "zh-Hant-HK", "en-HK"]
  },
  {
    label: "India",
    value: "IN",
    code: "INR",
    symbol: "‎₹‎",
    locales: [
      "as-IN",
      "bn-IN",
      "en-IN",
      "gu-IN",
      "hi-IN",
      "kn-IN",
      "kok-IN",
      "ml-IN",
      "mr-IN",
      "ne-IN",
      "or-IN",
      "ta-IN",
      "te-IN",
      "bo-IN",
      "ur-IN"
    ]
  },
  {
    label: "Ireland",
    value: "IE",
    code: "EUR",
    symbol: "€",
    locales: ["en-IE", "ga", "ga-IE"]
  },
  {
    label: "Italy",
    value: "IT",
    code: "EUR",
    symbol: "€",
    locales: ["it", "it-IT"]
  },
  {
    label: "Japan",
    value: "JP",
    code: "JPY",
    symbol: "¥",
    locales: ["ja", "ja-JP"]
  },
  {
    label: "Latvia",
    value: "LV",
    code: "EUR",
    symbol: "€",
    locales: ["lv", "lv-LV"]
  },
  {
    label: "Lithuania",
    value: "LT",
    code: "EUR",
    symbol: "€",
    locales: ["lt", "lt-LT"]
  },
  {
    label: "Luxembourg",
    value: "LU",
    code: "EUR",
    symbol: "€",
    locales: ["de-LU", "fr-LU"]
  },
  {
    label: "Malaysia",
    value: "MY",
    code: "MYR",
    symbol: "RM",
    locales: ["ms", "ms-MY", "ms-BN"]
  },
  {
    label: "Malta",
    value: "MT",
    code: "EUR",
    symbol: "€",
    locales: ["es-MT"]
  },
  {
    label: "Mexico",
    value: "MX",
    code: "MXN",
    symbol: "$",
    locales: ["es-MX"]
  },
  {
    label: "Netherlands",
    value: "NL",
    code: "EUR",
    symbol: "€",
    locales: ["nl-NL", "nl"]
  },
  {
    label: "New Zealand",
    value: "NZ",
    code: "NZD",
    symbol: "$",
    locales: ["en-NZ"]
  },
  {
    label: "Norway",
    value: "NO",
    code: "NOK",
    symbol: "kr",
    locales: ["nn", "nb", "nb-NO", "nn-NO"]
  },
  {
    label: "Poland",
    value: "PL",
    code: "PLN",
    symbol: "zł",
    locales: ["pl", "pl-PL"]
  },
  {
    label: "Portugal",
    value: "PT",
    code: "EUR",
    symbol: "€",
    locales: ["pt-PT"]
  },
  {
    label: "Romania",
    value: "RO",
    code: "RON",
    symbol: "L",
    locales: ["ro", "ro-RO"]
  },
  {
    label: "Singapore",
    value: "SG",
    code: "SGD",
    symbol: "$",
    locales: ["en-SG", "zh-Hans-SG"]
  },
  {
    label: "Slovenia",
    value: "SI",
    code: "EUR",
    symbol: "€",
    locales: ["sl", "sl-SI"]
  },
  {
    label: "Spain",
    value: "ES",
    code: "EUR",
    symbol: "€",
    locales: ["en-ES"]
  },
  {
    label: "Sweden",
    value: "SE",
    code: "SEK",
    symbol: "kr",
    locales: ["sv", "sv-SE"]
  },
  {
    label: "Switzerland",
    value: "CH",
    code: "CHF",
    // Note: Important to not include period in symbol
    symbol: "Fr",
    locales: ["fr-CH"]
  },
  {
    label: "United Kingdom",
    value: "UK",
    code: "GBP",
    symbol: "£",
    locales: ["en-GB"]
  },
  {
    label: "United States of America",
    value: "US",
    code: "USD",
    symbol: "$",
    locales: ["en-US"]
  }
];

export const CURRENCY_CODES = CURRENCIES.reduce((memo, currency) => {
  memo[currency.code] = currency.code.toLowerCase();
  return memo;
}, {});

export const CURRENCY_SYMBOLS_MAP = CURRENCIES.reduce((memo, currency) => {
  memo[currency.code.toLowerCase()] = currency.symbol;
  return memo;
}, {});

export const CURRENCY_CODE_SET = uniq(CURRENCIES.map(({ code }) => code));

export const CURRENCY_OPTIONS = uniqBy(
  CURRENCIES.map((currency) => ({
    uid: currency.code.toLowerCase(),
    label: currency.code
  })),
  "uid"
);

export const THOUSAND_BASED_CODES = [CURRENCY_CODES.JPY];
